
import { UseFormRegister, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { NameField } from './fields/NameField';
import { EnterpriseControlsFieldSimple } from './fields/EnterpriseControlsFieldSimple';
import { ErrorBoundary } from '@/components/ui/error-boundary';
import type { FormData } from './types';

interface EssentialInformationProps {
  register: UseFormRegister<FormData>;
  errors: FieldErrors<FormData>;
  setValue: UseFormSetValue<FormData>;
  watch: UseFormWatch<FormData>;
}

export const EssentialInformation = ({ register, errors, setValue, watch }: EssentialInformationProps) => {
  console.log('EssentialInformation: Starting render');
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Essential Information</h3>
      <NameField register={register} errors={errors} />
      <ErrorBoundary>
        <EnterpriseControlsFieldSimple 
          register={register} 
          errors={errors} 
          setValue={setValue}
          watch={watch}
        />
      </ErrorBoundary>
    </div>
  );
};
